/**
 * @generated SignedSource<<beffd26702c1fb93009f615d2f452b77>>
 * @relayHash 930fc8bd5e25d21b0690fb26a3f27e33
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7dbfffcf512e41601c954827e0e1935af276e48f09bfba02009d6b26b4e1694d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiDevOpsBoardQuery } from './uiDevOpsBoardQuery.graphql';

const node: PreloadableConcreteRequest<uiDevOpsBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7dbfffcf512e41601c954827e0e1935af276e48f09bfba02009d6b26b4e1694d",
    "metadata": {},
    "name": "uiDevOpsBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
